export default __webpack_public_path__ + "static/media/News & Announcements.c377abcb.svg";